import moment from 'moment-timezone'

class TimezoneFinder {
  timezone = (): string => {
    let timezone

    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch (error) {
      // do nothing2
    }

    return timezone || moment.tz.guess() || 'UTC'
  }
}

export default new TimezoneFinder()
